const EXTRA_TAG = "extra";

export class Coupon {
  constructor(
    public code: string,
    public amount: number,
    public tags: string[]
  ) { }

  get isExtra() {
    return this.tags.includes(EXTRA_TAG);
  }
}
